module.exports = __webpack_public_path__ + "img/project-8.5eb5346d.png";